/*import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')*/


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { createApp } from "vue";
import App from "./App.vue";
import VueSignaturePad from 'vue-signature-pad';
import VueCordova from 'vue-cordova'
//import BootstrapVue from 'bootstrap-vue'
import 'vue-universal-modal/dist/index.css'
import VueUniversalModal from 'vue-universal-modal'


import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faUserSecret)

//const init = () => {
    createApp(App).use(VueCordova).use(VueSignaturePad).use(VueUniversalModal).component('font-awesome-icon', FontAwesomeIcon).mount("#app");
//}
import "bootstrap/dist/js/bootstrap.js"

document.addEventListener("deviceready", onDeviceReady, false);
function onDeviceReady() {
    console.log(navigator.camera);
}

/*document.addEventListener('deviceready', function () {
    // eslint-disable-next-line
    console.log("Ready, Render the App");
    init();
    console.log(window)
}, false)*/